import styled from 'styled-components';
import { breakpoint } from 'theme';

import typography from 'components/atoms/typography';

import MapDesktop from './map-desktop';
import MapMobile from './map-mobile';
import { PaddingType } from './our-departments';

export const StyledWrapper = styled.div<PaddingType>`
  display: flex;
  justify-content: center;
  padding-inline: ${({ theme }) => theme.gap.sm};
  padding-bottom: ${({ theme }) => theme.gap.md};

  ${breakpoint.lg} {
    padding-bottom: ${({ isSmallPadding }) => (isSmallPadding ? '72px' : '144px')};
  }

  .map-point {
    &__label {
      font-weight: 600;
      font-size: 10px;

      &--desktop {
        display: none;
        font-size: 14px;
      }
    }

    &:hover {
      .map-point__border {
        width: 11px;
        height: 11px;
        stroke-width: 7;
        transform: translate(2px, 2px);
      }

      .map-point__label--desktop {
        display: block;
      }
    }
  }
`;

export const StyledContentWrapper = styled.div`
  display: flex;
  max-width: 1440px;
  width: 100%;
  justify-content: flex-end;
`;

export const StyledContent = styled.div`
  max-width: 1275px;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  height: max-content;
  align-items: center;

  ${breakpoint.lg} {
    flex-direction: row;
    padding-top: 40px;
  }
`;

export const StyledMapDesktop = styled(MapDesktop)`
  ${breakpoint.lg} {
    top: 0;
    right: 0;
    scale: 1;
    position: absolute;
  }
`;

export const StyledMapMobile = styled(MapMobile)`
  margin: 0 auto;
  padding-block: ${({ theme }) => theme.gap.md};

  ${breakpoint.sm} {
    scale: 1.2;
  }
`;

export const StyledDepartmentsSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  ${breakpoint.lg} {
    max-width: 444px;
  }
`;

export const StyledDepartments = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray10};
  z-index: 1;
`;

export const StyledDepartment = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding-block: ${({ theme }) => theme.gap.sm};
  border-top: 1px solid ${({ theme }) => theme.colors.gray10};

  [data-variant='title3'] {
    transition-property: color;
    transition-duration: 200ms;
    transition-timing-function: ease;
  }

  .text-animation {
    font-weight: 600;
  }

  ${breakpoint.lg} {
    padding-block: ${({ theme }) => theme.gap.smd};

    .text-animation {
      opacity: 0;
    }

    &:hover {
      [data-variant='title3'] {

        color: #838791;
      }

      .text-animation {
        animation: move-text 0.2s linear forwards;
      }
    }
  }

  svg {
    color: ${({ theme }) => theme.colors.primary50};
  }
}

@keyframes move-text {
  from {
    opacity: 0;
    transform: translateY(-100%);
  }
  to {
    opacity: 1;
    transform: translateY(0%);
  }
`;

export const StyledWrapperArrowText = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.gap.xs};
`;

export const StyledTitle = styled(typography)`
  padding-bottom: ${({ theme }) => theme.gap.sm};
`;

export const StyledDescription = styled(typography)`
  ${breakpoint.lg} {
    padding-bottom: ${({ theme }) => theme.gap.lg};
  }
`;
